import { UserManager, UserManagerSettings, Log, User, WebStorageStateStore } from "oidc-client-ts";

/**
 * @hidden
 */
export class Auth {
    private mgr: UserManager;

    public user: User;

    private setUserRefreshFunction: (user: User) => void;

    private getUserManagerSettings(baseUrl: string, clientId: string): UserManagerSettings {
        let fullUrl = window.location.origin + baseUrl + "/";
        if (clientId == "dms-config") {
            return {
                authority: baseUrl + "/",
                client_id: clientId,
                redirect_uri: fullUrl + "Account/CallbackDmsConfig",
                post_logout_redirect_uri: fullUrl,

                response_type: "code",
                scope: "openid profile email dmsapi dmsconfig",
                loadUserInfo: true,
                silent_redirect_uri: fullUrl + "Account/Silent",
                automaticSilentRenew: true,
                stateStore: new WebStorageStateStore({ store: window.sessionStorage }),
            };
        } else {
            return {
                authority: baseUrl + "/",
                client_id: clientId,
                redirect_uri: fullUrl + "Account/Callback",
                post_logout_redirect_uri: fullUrl,
                response_type: "code",
                scope: "openid profile email dmsapi",
                loadUserInfo: true,
                silent_redirect_uri: fullUrl + "Account/Silent",
                automaticSilentRenew: true,
                stateStore: new WebStorageStateStore({ store: window.sessionStorage }),
            };
        }
    }

    public async init(baseUrl: string, clientId: string): Promise<User> {
        const config = this.getUserManagerSettings(baseUrl, clientId);
        Log.setLevel(Log.INFO);
        Log.setLogger(window.console);

        // Log.logger = window.console;
        // Log.level = Log.INFO;

        this.mgr = new UserManager(config);
        this.mgr.clearStaleState(); // clear all unused items from localstorage
        this.user = await this.mgr.getUser();

        if (this.user && this.user.expired) {
            this.mgr.events.addSilentRenewError(() => {
                this.mgr.signoutRedirect();
            });
            try {
                this.user = await this.mgr.signinSilent();
            } catch {
                this.mgr.clearStaleState();
                await this.mgr.signinRedirect({
                    state: window.location.href,
                });
                return null;
            }
        }

        if (!this.user) {
            if (clientId == "dms-config") {
                await this.mgr.signinRedirect({ prompt: "login" });
                return null;
            } else {
                try {
                    this.user = await this.mgr.signinSilent();
                } catch {
                    this.mgr.clearStaleState();
                    await this.mgr.signinRedirect({
                        state: window.location.href,
                    });
                    return null;
                }
            }
        }

        if (this.setUserRefreshFunction) {
            this.setUserRefreshFunction(this.user);
        }
        this.mgr.events.addUserLoaded((user) => {
            if (this.setUserRefreshFunction) {
                this.setUserRefreshFunction(user);
            }
            this.user = user;
        });

        // this.mgr.events.addUserSignedOut(() => {
        //     this.mgr.signoutRedirect();
        // });

        this.mgr.events.addSilentRenewError(() => {
            this.mgr.signoutRedirect();
        });

        this.mgr.events.addAccessTokenExpiring(() => {
            this.mgr.startSilentRenew();
        });
        return this.user;
    }

    public impersonate(userId: number) {
        this.mgr.signinRedirect({
            acr_values: "impersonate",
            login_hint: userId.toString(),
            prompt: "login",
        });
    }

    public logout(): void {
        this.mgr.signoutRedirect();
    }

    public setUserRefreshCallback(func: (user: User) => void) {
        this.setUserRefreshFunction = func;
    }

    public performCallback(redirectUrl: string, baseUrl: string, isDmsConfig: boolean): void {
        const config = this.getUserManagerSettings(baseUrl, isDmsConfig ? "dms-config" : "dms-web");
        config.filterProtocolClaims = true;
        config.response_mode = "query";
        const mgr = new UserManager(config);
        mgr.signinCallback()
            .then((user) => {
                window.history.replaceState({}, window.document.title, window.location.origin + window.location.pathname);
                window.location.href = (<any>user).state ?? redirectUrl;
            })
            .catch((err) => {
                mgr.clearStaleState();
                mgr.signinRedirect({ state: redirectUrl });
            });
    }

    public performSilent(): void {
        let mgr = new UserManager(<any>{
            loadUserInfo: true,
            filterProtocolClaims: true,
            response_mode: "query",
            stateStore: new WebStorageStateStore({ store: window.sessionStorage }),
        });
        mgr.signinCallback();
    }
}
